import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

import { ReconcileTicketView } from '@appshared';

@Injectable({
  providedIn: 'root',
})
export class ReconcileTicketService {
  private advanceFilter = new BehaviorSubject('');
  viewMode = ReconcileTicketView.MASTER_LIST;
  advanceFilterData = this.advanceFilter.asObservable();

  constructor(public _http: HttpClient) {}

  updateFilterArr(allList = [], selectedList = []): Array<any> {
    const filterArr = [];
    if (!selectedList || selectedList.length === 0) {
      if (allList && allList.length > 0) {
        allList.forEach(item => (item.selected = false));
      }
      return filterArr;
    }
    allList.forEach(itemBrand => {
      if (selectedList.find(itemToFind =>
            (itemToFind.code && itemToFind.code === itemBrand.code) ||
            (itemToFind.shortCode && itemToFind.shortCode === itemBrand.shortCode)
        )) {
        itemBrand.selected = true;
        filterArr.push(itemBrand);
      } else {
          itemBrand.selected = false;
      }
    });
    return filterArr;
  }

  removeItemInList(list = [], index = -1): void {
    if (index > -1) {
      list.splice(index, 1);
    }
  }

  changeFilterData(data: any): void {
    this.advanceFilter.next(data);
  }
}
